import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import {
  Paper,
  Typography,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  TableHead,
  Grid,
  Box,
} from "@mui/material"; import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
import { FullPageSpinner } from '../lib';
import InputBox from '../shared/components/InputBox';
import umlauteErsetzen from "../shared/functions/umlauteErsetzen";
import { useSessionStorage } from '../../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import TextField from "@mui/material/TextField";

function AuToDo() {
  const { t } = useTranslation();
  let { todokey } = useParams();
  const [questions, setQuestions] = useState([]);
  const [aufgabenDaten, setAufgabenDaten] = useState({})
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const navigate = useNavigate();
  const loadQuestions = () => {
    setIsLoading(true);
    const payload = {
      "statement": "HAUF_LESEN",
      "aufgabe": todokey.substring(3),
      "aufgabeVon": todokey.substring(0, 3),
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'aufgaben', payload, headers, questionsCb);
  }
  useEffect(() => {
    loadQuestions();
    // eslint-disable-next-line
  }, [])
  const errorCb = () => {
    setIsSending(false);
    showErrorMessage(t("Änderung konnte nicht gesendet werden. Bitte versuchen Sie es erneut."));
  }
  const questionsCb = (response) => {
    if (response.status === 200) {
      setAufgabenDaten(response.data.aufgabe)
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const cancel = () => {
    navigate(-1)
  }
  if (isLoading) {
    return <LoadingComponent />
  }
  const finishTodo = () => {
    const payload = {
      "statement": "FINISH_HAUF",
      "aufgabe": todokey.substring(3),
      "aufgabeVon": todokey.substring(0, 3),
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'aufgaben', payload, headers, finishCb);
  }
  const finishCb = (response) => {
    navigate(-1)
  }
  return (
    <Page>
      <Layout>
        <Box p={2}>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} lg={8} spacing={3}>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
              >

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Bezeichnung der Aufgabe")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={aufgabenDaten?.bezKurz}
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField                 
                    variant="outlined"
                    label={t("Zeitraum")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={aufgabenDaten?.zeitraum}
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Bemerkung")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={aufgabenDaten?.bemerkung}
                  ></TextField>
                </Grid>
                <Grid item xs={6}>
                  <Button fullWidth variant="contained"
                    color="primary" onClick={() => finishTodo()}>Zur Kenntnis genommen</Button>
                </Grid>
                <Grid item xs={6}>
                  <Button fullWidth variant="contained"
                    color="primary" onClick={() => navigate(-1)}>Abbrechen</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Layout>
      {isSending && <FullPageSpinner />}
    </Page>
  )
}
export default AuToDo;
